import Disclosure from 'core/components/disclosure/disclosure';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { ActionButton } from 'core/components/action-button';
import deleteIcon from 'core/assets/svg/delete-icon.svg';
import caret from 'core/assets/svg/caretOrange.svg';
import alertIcon from 'core/assets/svg/alert-bold-on-card.svg';
import useStyles from './sub-risk.styles';
import { EditControl } from 'common/disabled-context/read-only';

const CollapsibleListItem = ({ title, rightSideValues, onDelete, disabled, alertMessage, children }) => {
  const classes = useStyles();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={classes.item}>
      <div className={classes.itemTitleRow}>
        <div className={classes.itemTitle}>{title}</div>

        {rightSideValues.map((valueItem, index) => (
          <React.Fragment key={index}>
            {valueItem.label && <div className={classes.divider} />}
            <div className={classes.itemStack}>
              {valueItem.label && <span className={classes.itemLabel}>{valueItem.label}</span>}
              <span className={classes.itemValue}>{valueItem.value}</span>
            </div>
          </React.Fragment>
        ))}

        <Grid container justifyContent="flex-end" className={classes.actionButtons}>
          <EditControl>
            <ActionButton
              onClick={(e) => {
                e.stopPropagation();
                onDelete();
              }}
              className={classes.deleteButton}
              icon={deleteIcon}
              size="small"
              disabled={disabled}
            />
          </EditControl>
          <IconButton onClick={toggleExpanded} aria-expanded={isExpanded} className={classes.expandIcon} size="small">
            <img
              className={isExpanded ? classes.icon : classes.iconFold}
              src={caret}
              alt={isExpanded ? 'fold' : 'unfold'}
            />
          </IconButton>
        </Grid>
      </div>

      <Disclosure open={isExpanded}>
        <div className={classes.itemContent}>
          <Grid container xs={12} spacing={2}>
            {children}
            {alertMessage && (
              <Grid container xs={12} className={classes.alert}>
                <img src={alertIcon} className={classes.alertIcon} alt="Alert Icon" />
                <div className={classes.alertMessage}>{alertMessage}</div>
              </Grid>
            )}
          </Grid>
        </div>
      </Disclosure>
    </div>
  );
};

CollapsibleListItem.propTypes = {
  title: PropTypes.node.isRequired,
  rightSideValues: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.node.isRequired
    })
  ).isRequired,
  onDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  alertMessage: PropTypes.string,
  children: PropTypes.node
};

CollapsibleListItem.defaultProps = {
  disabled: false,
  alertMessage: null
};

export default CollapsibleListItem;
